export const useHighlight = () => {
  const listeners = new WeakMap<HTMLElement, (e: AnimationEvent) => void>();

  function highlight(el: HTMLElement | null, className: string) {
    if (!el) {
      return;
    }

    const existing = listeners.get(el);

    if (existing) {
      el.removeEventListener("animationend", existing);
    }

    el.classList.add(className);

    const handler = () => {
      el.classList.remove(className);
      el.removeEventListener("animationend", handler);
      listeners.delete(el);
    };

    listeners.set(el, handler);

    el.addEventListener("animationend", handler);
  }

  return { highlight };
};
